export default {
  stickyMenuOffset: 80,
  stickyMenuOffsetMobile: 80,
};
